import React, { useState, useEffect } from "react";
import Translations from "../../services/translation.service";
import PaciService from "../../services/paci_connection.service";
import OcrService from "../../services/ocr_service.service";
import StmSummary from "../shared/storefront-summary";
import CONSTANTS from "../../services/constants.service";
import FirebaseAnalytics from "../../services/analytics.service";
import SpinnerKw from "../shared/spinner_kw";
import StorefrontTitle from "../shared/storefront-title.component";
import Helpers from "../../helpers/shared.helper";

const subscriptions = [];
const ScanId = (props) => {
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [kuwaitId, setKuwaitId] = useState("");
  const [loading, setLoading] = useState(false);
  const [valid, setValid] = useState(false);

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  const getInputValue = (value) => {
    const valid = OcrService.checkFieldValidity(value, {
      required: true,
      numberOnly: true,
      maxLength: 12,
      minLength: 12,
    });
    setKuwaitId(value);
    setValid(valid);
  };

  const handleSubmit = () => {
    FirebaseAnalytics.button_clicked(CONSTANTS.PACI_SCREEN, "ob_scan_next");
    setLoading(true);
    if (kuwaitId?.length && kuwaitId !== "") {
      PaciService.checkSubmit({
        civilId: kuwaitId,
      })
        .then((response) => {
          setLoading(false);
          if (
            response &&
            response?.data &&
            response?.data?.HasPACI &&
            response?.data?.HasPACI === true
          ) {
            props.history.push("/paci/connection");
          } else {
            props.history.push("/scan/id");
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("paci connection catch issue:", error);
        });
    }
  };

  // const redirectToOcr = () => {
  //     props.history.push("/scan/id");
  // }

  return (
    <div className="storefront-two-col-pg">
      <div className="stf-scan-id-page">
        <StorefrontTitle
          title={translationKeys["ob_ocr_scan_kuwaiti_id"]}
          desc={translationKeys["ob_ocr_you_can_continue_entering_id"]}
        />
        {loading && (
          <div className="translation-loading-spinner">
            <SpinnerKw />
          </div>
        )}
        {Helpers.checkEnableSocialLogin("enableOldPACIFlow") &&
        <>
          <div className="field-container">
            <label>{translationKeys["ob_eligibility_id_number"]}</label>
            <input
              className={`storefront-search-input ${!valid ? "stf-invalid" : "stf-valid"
                }`}
              type="text"
              pattern="[0-9]{3}"
              value={kuwaitId}
              placeholder={translationKeys["stf_scan_id_number_placeholder"]}
              onChange={(e) => getInputValue(e?.target?.value)}
            />
            {/* <div className="hint-section">
                                <img src={hint} alt="hint" />
                                <p>You can just scan the code by using the icon appears on the right of the field.</p>
                            </div> */}
            {/* <label className="form-lbl">{translationKeys["kw_adress_paci_number"]}</label> */}
          </div>
          <button
            className="common-button"
            onClick={handleSubmit}
            disabled={!kuwaitId?.length || !valid}
          >
            {translationKeys["ob_scan_next"]}
          </button>
        </>
        }
      </div>
      <StmSummary />
    </div>
  );
};

export default ScanId;
